import React from 'react'
import { ScrollView, StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Header, Screen, Text } from '@components'
import { useLanguage } from '@context'
import { useFooterPageBack } from './useFooterPageBack'

export const LegalNotice: React.FC = () => {
  const theme = useTheme()
  const { t } = useLanguage()
  const onPressBack = useFooterPageBack()
  const styles = getStyles(theme)

  return (
    <Screen>
      <Header
        title={t('webFooter.legalNotice')}
        iconLeft="arrowBack"
        onPressLeft={onPressBack}
      />
      <ScrollView style={styles.content} showsVerticalScrollIndicator={false}>
        <View style={styles.section}>
          <Text type="headline" color={theme.colors.black} style={styles.sectionTitle}>
            {t('legalNotice.editor')}
          </Text>
          <Text type="body" color={theme.colors.secondary}>
            {t('legalNotice.editorContent')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text type="headline" color={theme.colors.black} style={styles.sectionTitle}>
            {t('legalNotice.hosting')}
          </Text>
          <Text type="body" color={theme.colors.secondary}>
            {t('legalNotice.hostingContent')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text type="headline" color={theme.colors.black} style={styles.sectionTitle}>
            {t('legalNotice.intellectualProperty')}
          </Text>
          <Text type="body" color={theme.colors.secondary}>
            {t('legalNotice.intellectualPropertyContent')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text type="headline" color={theme.colors.black} style={styles.sectionTitle}>
            {t('legalNotice.liability')}
          </Text>
          <Text type="body" color={theme.colors.secondary}>
            {t('legalNotice.liabilityContent')}
          </Text>
        </View>
      </ScrollView>
    </Screen>
  )
}

const getStyles = (theme: Theme) =>
  StyleSheet.create({
    content: {
      flex: 1,
      paddingHorizontal: theme.spacing.xl,
    },
    section: {
      marginBottom: theme.spacing.xxl,
    },
    sectionTitle: {
      marginBottom: theme.spacing.sm,
    },
  })
